import { baseErrorMessages } from '@repo/lib/messages/baseErrorMessages';
import { useQuery } from '@tanstack/react-query';

import { useErrorMessage } from '#error-message/useErrorMessage';

import { ParentKey } from './keys';
import { ParentService } from './parentService';

/**
 * Children linked to the authenticated parent. The entry point for every
 * parent view — the per-child hooks all take ids from this list.
 */
export function useGetMyChildren(enabled = true) {
  const getMyChildrenQuery = useQuery({
    queryKey: [ParentKey.MY_CHILDREN],
    queryFn: () => ParentService.getMyChildren().then((response) => response.data),
    enabled,
  });
  const errorMessage = useErrorMessage(getMyChildrenQuery.error, baseErrorMessages);
  return { ...getMyChildrenQuery, errorMessage };
}
